var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};
var CANCEL = /*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE = /*#__PURE__*/
createSymbol('CHANNEL_END');
var IO = /*#__PURE__*/
createSymbol('IO');
var MATCH = /*#__PURE__*/
createSymbol('MATCH');
var MULTICAST = /*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION = /*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION = /*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK = /*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL = /*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE = /*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION = /*#__PURE__*/
createSymbol('LOCATION');
export { CANCEL, CHANNEL_END_TYPE, IO, MATCH, MULTICAST, SAGA_ACTION, SAGA_LOCATION, SELF_CANCELLATION, TASK, TASK_CANCEL, TERMINATE };